import React from "react";

const ProgressChartSection = ({
  configs = [],
  selectedConfigId,
  setSelectedConfigId,
  chartData = [],
  onAdd,
  onDelete, 
}) => {
  const handleConfigChange = (e) => {
    const id = e.target.value;
    setSelectedConfigId && setSelectedConfigId(id);
  };

  const selectedConfig = configs.find((c) => c._id === selectedConfigId);

  return (
    <div className="rounded-2xl bg-white/80 border shadow p-4 w-full">
      {/* Header */}
      <div className="flex items-center justify-between gap-1 mb-1">
        <h3
          className="text-sm font-semibold truncate"
          title={selectedConfig?.heading || ""}
        >
          {selectedConfig?.heading || "Progress Chart"}
        </h3>

        <div className="flex items-center gap-2">
          {/* ✅ Delete button */}
          {selectedConfigId && onDelete && (
            <button
              type="button"
              onClick={onDelete}
              className="rounded-full border border-red-200 bg-red-50 px-3 py-1 text-xs font-medium text-red-600 hover:bg-red-100"
            >
              🗑 Delete
            </button>
          )}

          <button
            onClick={onAdd}
            className="rounded-full border border-sky-300 bg-white px-3 py-1 text-xs text-sky-600 hover:bg-sky-50"
          >
            ＋ Add
          </button>
        </div>
      </div>

      {/* Config selector (if multiple progress configs) */}
      {configs.length > 1 && (
        <select
          value={selectedConfigId || ""}
          onChange={handleConfigChange}
          className="max-w-[160px] rounded-full border border-slate-200 bg-slate-50 px-2 py-1 text-[11px] text-slate-700 focus:outline-none focus:ring-1 focus:ring-sky-400"
        >
          {configs.map((cfg) => (
            <option key={cfg._id} value={cfg._id}>
              {cfg.heading || "Untitled config"}
            </option>
          ))}
        </select>
      )}

      {/* Progress list */}
      <div className="mt-2 space-y-3 text-xs">
        {chartData && chartData.length > 0 ? (
          chartData.map((item) => {
            const progress = Math.max(0, Math.min(item.value ?? 0, 100));
            const percent =
              typeof item.percent === "number" ? item.percent : progress;
            const rawCount = item.rawCount ?? 0;

            const tooltip = `${
              item.label || ""
            }\n${percent.toFixed(1)}% (${rawCount} responses)`;

            return (
              <div key={item.label} className="space-y-1">
                <div className="flex justify-between items-center">
                  <span className="truncate max-w-[60%]">
                    {item.label}
                  </span>
                  <span className="text-sky-600 font-medium">
                    {item?.value} / 100
                  </span>
                </div>

                {/* Progress bar with tooltip on hover */}
                <div
                  className="w-full h-3 bg-slate-100 rounded-full overflow-hidden cursor-pointer"
                  title={tooltip}
                >
                  <div
                    className="h-full bg-sky-500 rounded-full transition-all duration-100"
                    style={{ width: `${progress}%` }}
                  />
                </div>
              </div>
            );
          })
        ) : (
          <p className="text-[11px] text-slate-400 italic">
            No progress data available yet.
          </p>
        )}
      </div>
    </div>
  );
};

export default ProgressChartSection;
